import React, { useContext, useEffect, useState } from 'react';
import {
  BackgroundContainer,
  Container,
  DesktopSideNav,
  DocumentContainer,
  ListView,
  MainHeading,
  Header,
  GridContainer,
  Image,
  InnerContainer,
  DocumentProperty,
  ImageContainer,
  Middle,
  Text,
  View,
  Download,
  Loader,
  SeeMore,
  MobileFilterContainer,
  DocInnerContainer,
  EllipsisIcon,
  NoDataText,
  NoDataCard,
} from '@app/modules/documents/documents-list-component';
import { AuthContext } from '@app/providers';
import SideNav from '@app/modules/transactions/transactions-sidenav';
import moment from 'moment';
import { TransactionFilters } from '@app/types';
import { useGetDocumentsList } from '@app/graphql';
import docLogo from '@app/components/icon/icons/doc-logo.svg';
import pdfLogo from '@app/components/icon/icons/pdf-logo.svg';
import excelLogo from '@app/components/icon/icons/excel-logo.svg';
import csvLogo from '@app/components/icon/icons/csv-logo.svg';
import pngLogo from '@app/components/icon/icons/png-logo.svg';
import jpegLogo from '@app/components/icon/icons/jpeg-logo.svg';
import { Icon, SearchNew } from '@app/components';
import { UploadDocType } from '@app/types/documents';
import { viewS3Document } from '../transaction-form/uploaded-document';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { StyledMenu } from '@app/modules/transactions/transactions-components';
import DefaultErroPage from '@app/components/error-pages/default-error-page';

const logos: any = {
  'application/vnd.ms-excel': excelLogo,
  'application/pdf': pdfLogo,
  'application/msword': docLogo,
  'image/png': pngLogo,
  'text/csv': csvLogo,
  'image/jpeg': jpegLogo,
};
const MenuIconStyle = {
  height: 35,
  width: 30,
};

type DocumentProps = {
  page: number;
  search: string;
  limit: number;
};
type ViewDOcProps = {
  show: boolean;
  index: any;
};

export default function DocumentsList() {
  const { userInfo }: any = useContext(AuthContext);
  const [documents, setDocuments] = useState([]);
  const [showErrorPage, SetShowErrorPage] = useState(false);
  const [getDocumentsList] = useGetDocumentsList();
  const [seeMoreText, setSeeMoreText] = useState('See More');
  const [searchText, setSearchText] = useState('');
  const [openSideNav, setOpenSideNav] = React.useState<boolean>(false);
  const [payload, setPayload] = useState({
    page: 1,
    limit: 20,
    search: '',
  });
  const [isMobile, setIsMobile] = React.useState(
    window.innerWidth < 768 ? true : false,
  );

  const [pageDetails, setPageDetails] = useState({
    totalRecords: 0,
    currentPage: 0,
    totalPages: 0,
  });
  const [documentsLoading, setDocumentsLoading] = useState(true);
  const DOWNLOAD_URL = process.env.REACT_APP_DOWNLOAD_URL;
  const [viewDoc, setViewDoc] = useState<ViewDOcProps>({
    show: false,
    index: null,
  });
  const [filters, setFilters] = React.useState<TransactionFilters>({
    municipalities: '',
    createdDateRange: {
      startDate: moment()
        .subtract(30, 'day')
        .format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },
    status: '',
  });

  const [showDropdown, setShowDropdown] = React.useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const sideNavRef: any = React.useRef(null);
  function handleClickOutside(e: any) {
    if (
      showDropdown &&
      sideNavRef.current &&
      !sideNavRef.current.contains(e.target)
    ) {
      setShowDropdown(false);
      setSelectedIndex(0);
    }
  }
  document.addEventListener('mousedown', handleClickOutside);
  window.addEventListener('resize', function() {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  });

  useEffect(() => {
    getTransactionDocuments({ ...payload, search: searchText });
    // eslint-disable-next-line
  }, []);

  /**
   *
   * @param params parameter required to get document list
   */
  function getTransactionDocuments(params: DocumentProps) {
    Object.assign(params, {
      firebaseId: userInfo && userInfo.firebaseId ? userInfo.firebaseId : '',
    });
    setSeeMoreText('Loading...');
    getDocumentsList({ variables: params })
      .then((response: any) => {
        if (response && response.data) {
          const { getTransactionsDocumentsByUserId } = response.data;
          if (getTransactionsDocumentsByUserId) {
            const {
              transactionDocuments,
              success,
              totalPages,
              currentPage,
              totalRecords,
            } = getTransactionsDocumentsByUserId;
            if (
              success &&
              transactionDocuments &&
              transactionDocuments.length
            ) {
              let docs =
                currentPage > 1
                  ? documents.concat(transactionDocuments)
                  : transactionDocuments;
              setDocuments(docs);
              setPayload({
                ...payload,
                page: currentPage + 1,
                search: searchText,
              });
              setSeeMoreText('See More');
              setPageDetails({
                totalPages: totalPages,
                currentPage: currentPage,
                totalRecords: totalRecords,
              });
            }
            setDocumentsLoading(false);
          }
        }
      })
      .catch((error: any) => {
        setDocumentsLoading(false);
        SetShowErrorPage(true);
      });
  }

  const applyFilters = (appliedFilters: TransactionFilters) => {
    if (JSON.stringify(filters) !== JSON.stringify(appliedFilters)) {
      setFilters(appliedFilters);
      setOpenSideNav(false);
    }
  };

  const resetFilters = (appliedFilters: TransactionFilters) => {
    if (JSON.stringify(filters) !== JSON.stringify(appliedFilters)) {
      setFilters(appliedFilters);
      setOpenSideNav(false);
    }
  };

  /**
   *
   * @param contentType content type of the selected document
   * @returns boolean
   */
  function checkDocContentType(contentType: string) {
    if (
      contentType &&
      (contentType === 'image/png' ||
        contentType === 'image/jpeg' ||
        contentType === 'application/pdf')
    ) {
      return true;
    }
    return false;
  }

  /**
   *
   * @param doc selected document
   * @param index index of the selected document
   */
  function viewDocument(doc: UploadDocType, index: number) {
    setViewDoc({ show: true, index: index });
    if (doc) {
      viewS3Document(doc, setViewDoc, index);
    } else {
      setViewDoc({ show: false, index: null });
    }
  }

  /**
   *
   * @param e event
   */
  const handleTransactionSearch = (e: any) => {
    setDocuments([]);
    setSearchText(e.target.value);
    getTransactionDocuments({
      ...payload,
      page: 1,
      search: e.target.value,
    });
  };

  const viewDowloadDoc = (document: UploadDocType, index: number) => {
    return (
      <Middle className="middle" ref={sideNavRef}>
        {checkDocContentType(document.docContentType) &&
        !viewDoc.show &&
        viewDoc.index !== index ? (
          <View className="text">
            <Icon name="viewIcon" />
            <Text onClick={() => viewDocument(document, index)}>View</Text>
          </View>
        ) : null}
        {viewDoc.show && viewDoc.index === index ? (
          <View>
            <Icon name="loader" />
            <Text>Loading...</Text>
          </View>
        ) : null}
        <Download className="text">
          <Icon name="downloadIcon" />
          <Text>
            <a
              href={`${DOWNLOAD_URL}downloadFile?key=${document.docUrl}&docType=transDoc`}
              download>
              Download
            </a>
          </Text>
        </Download>
      </Middle>
    );
  };
  /**
   * function to load more documents
   */
  function loadMore() {
    getTransactionDocuments({ ...payload, search: searchText });
  }

  function onClear() {
    setSearchText('');
    getTransactionDocuments({
      ...payload,
      page: 1,
      search: '',
    });
  }

  return (
    <>
      {showErrorPage ? (
        <DefaultErroPage />
      ) : (
        <>
          <BackgroundContainer>
            <Container>
              <DesktopSideNav>
                <SideNav
                  filters={filters}
                  applyFilters={applyFilters}
                  isListLoading={true}
                  resetFilters={resetFilters}
                />
              </DesktopSideNav>
              <StyledMenu open={openSideNav}>
                <SideNav
                  filters={filters}
                  applyFilters={applyFilters}
                  isListLoading={true}
                  resetFilters={resetFilters}
                  closeSideNav={() => {
                    setOpenSideNav(false);
                  }}
                />
              </StyledMenu>
              {documentsLoading ? (
                <Loader>
                  <Icon name="loader" />
                </Loader>
              ) : (
                <ListView>
                  <Header>
                    <MainHeading>
                      All Documents ({documents && documents.length})
                      <MobileFilterContainer
                        onClick={() => {
                          setOpenSideNav(true);
                        }}>
                        <FontAwesomeIcon color="black" icon={faSlidersH} />
                      </MobileFilterContainer>
                    </MainHeading>
                    <SearchNew
                      placeholder="Search here..."
                      value={searchText}
                      onClear={onClear}
                      onChange={(e: any) => handleTransactionSearch(e)}
                    />
                  </Header>
                  <GridContainer>
                    {documents && documents.length ? (
                      documents.map(
                        (document: UploadDocType, index: number) => {
                          return (
                            <>
                              <DocumentContainer key={document.docUniqueId}>
                                <DocInnerContainer>
                                  <ImageContainer className="container">
                                    <Image
                                      src={logos[document.docContentType]}
                                      alt="Avatar"
                                      className="image"
                                    />
                                    {!isMobile
                                      ? viewDowloadDoc(document, index)
                                      : null}
                                  </ImageContainer>
                                  <InnerContainer>
                                    <DocumentProperty
                                      type="title"
                                      title={document.title}>
                                      {document.title}
                                    </DocumentProperty>
                                    <DocumentProperty
                                      type="documentType"
                                      title={document.documentType}>
                                      {document.documentType || '--'}
                                    </DocumentProperty>
                                    <DocumentProperty
                                      type="date"
                                      title={document.uploadedDate}>
                                      Last Updated{':'}
                                      {moment(document.uploadedDate).format(
                                        'DD/MM/YYYY',
                                      )}{' '}
                                      by {document.uploadedBy}
                                    </DocumentProperty>
                                  </InnerContainer>
                                </DocInnerContainer>
                                {isMobile ? (
                                  <>
                                    <EllipsisIcon>
                                      <FontAwesomeIcon
                                        color={'#000000'}
                                        icon={faEllipsisV}
                                        style={MenuIconStyle}
                                        onClick={() => {
                                          setShowDropdown(!showDropdown);
                                          setSelectedIndex(index);
                                        }}
                                      />
                                    </EllipsisIcon>
                                    {showDropdown && selectedIndex === index
                                      ? viewDowloadDoc(document, index)
                                      : null}
                                  </>
                                ) : null}
                              </DocumentContainer>
                            </>
                          );
                        },
                      )
                    ) : (
                      <NoDataCard>
                        <NoDataText>No Documents Found</NoDataText>
                      </NoDataCard>
                    )}
                  </GridContainer>
                  {pageDetails.currentPage < pageDetails.totalPages ? (
                    <SeeMore onClick={loadMore}>{seeMoreText}</SeeMore>
                  ) : null}
                </ListView>
              )}
            </Container>
          </BackgroundContainer>
        </>
      )}
    </>
  );
}
